import * as angular from "angular";
import {IController} from "angular";

export class serviceAreasIndicatorCtrl implements IController {

  serviceAreas?: any[];
  serviceAreaIds: any;
  maxItems: number;
  showAll: any;

  private serviceAreasRef: any;

  /* @ngInject */
  constructor(private $serviceArea) {}

  $onInit() {
    this.serviceAreasRef = this.$serviceArea();

    if (!this.maxItems) {
      this.maxItems = 1;
    }

    if (!this.serviceAreas && this.serviceAreaIds) {
      this.serviceAreasRef.$asyncValues(this.serviceAreaIds)
        .then((serviceAreas) => {
          this.serviceAreas = serviceAreas;
        })
    }
  };

  $onChanges(changes) {
    if (changes.serviceAreaIds && !changes.serviceAreaIds.isFirstChange()) {
      this.serviceAreas = [];

      this.$onInit();
    }
  };

}
angular
  .module('bringoz.admin.service-areas')
  .component('serviceAreasIndicator', {
    bindings: {
      serviceAreas: '<?',
      serviceAreaIds: '<',
      maxItems: '<?',
      showAll: '<?'
    },
    template: require('./service-areas-indicator.html').default,
    controller: serviceAreasIndicatorCtrl
  });
